<template>
  <div class="medical-guidance-page">
    <my-nav-bar v-if="showAppBar" :title="'就医指引'" back @onBackClick="onBack"/>
    
    <div class="guidance-content">
      <div class="guidance-header">
        <div class="header-icon">
          <van-icon name="info-o" size="24" color="#1989fa"/>
        </div>
        <div class="header-text">
          <div class="header-title">您暂无训练方案</div>
          <div class="header-desc">请前往以下医院就诊获取专业康复指导</div>
        </div>
      </div>

      <div class="hospital-list">
        <div 
          v-for="(hospital, index) in hospitals" 
          :key="index"
          class="hospital-item"
        >
          <div class="hospital-header" @click="toggleHospital(index)">
            <div class="hospital-info">
              <div class="hospital-name">{{ hospital.name }}</div>
              <div class="hospital-departments-count">
                {{ hospital.departments.length }}个科室
              </div>
            </div>
            <van-icon 
              :name="hospital.expanded ? 'arrow-up' : 'arrow-down'" 
              size="18" 
              color="#969799"
            />
          </div>
          
          <div v-show="hospital.expanded" class="department-list">
            <div 
              v-for="(dept, deptIndex) in hospital.departments" 
              :key="deptIndex"
              class="department-item"
            >
              <van-icon name="location-o" size="16" color="#1989fa"/>
              <span class="department-name">{{ dept }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyNavBar from '@/h5/doucan/components/MyNavBar.vue'

export default {
  name: 'MedicalGuidancePage',
  components: {
    MyNavBar
  },
  data () {
    return {
      showAppBar: true,
      hospitals: [
        {
          name: '暨南大学附属顺德医院',
          departments: ['康复医学科'],
          expanded: true
        },
        {
          name: '广州中医药大学顺德医院',
          departments: ['康复科（针灸科、推拿科）'],
          expanded: true
        }
      ]
    }
  },
  mounted () {
    const query = this.$route.query
    if (query.from === 'wxapp') {
      this.showAppBar = false
    }
  },
  methods: {
    onBack () {
      this.$router.back()
    },
    toggleHospital (index) {
      this.hospitals[index].expanded = !this.hospitals[index].expanded
    }
  }
}
</script>

<style scoped>
.medical-guidance-page {
  min-height: 100vh;
  background: #f5f7fa;
}

.guidance-content {
  padding: 16px;
}

.guidance-header {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  border-radius: 12px;
  padding: 20px 16px;
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.header-icon {
  width: 48px;
  height: 48px;
  background: rgba(25, 137, 250, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.header-text {
  flex: 1;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 8px;
  line-height: 1.4;
}

.header-desc {
  font-size: 14px;
  color: #646566;
  line-height: 1.5;
}

.hospital-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.hospital-item {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.hospital-header {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: background-color 0.2s;
}

.hospital-header:active {
  background-color: #f7f8fa;
}

.hospital-info {
  flex: 1;
}

.hospital-name {
  font-size: 16px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 4px;
}

.hospital-departments-count {
  font-size: 13px;
  color: #969799;
}

.department-list {
  padding: 0 16px 16px;
  border-top: 1px solid #ebedf0;
  margin-top: 8px;
  padding-top: 12px;
}

.department-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  font-size: 14px;
  color: #323233;
}

.department-item:not(:last-child) {
  border-bottom: 1px solid #f7f8fa;
}

.department-item .van-icon {
  margin-right: 8px;
  flex-shrink: 0;
}

.department-name {
  flex: 1;
  line-height: 1.5;
}
</style>
